<template>
    <div class="f-item">
        <van-field
                :required="required?true:false"
                v-model="fieldModel"
                name="fieldModel"
                :right-icon="type=='see'?'':'arrow-down'"
                :label="label"
                :placeholder="type=='see'?'':'请选择'+label"
                readonly
                @click="sdata && sdata.length>0 ? onShowField():errshowTip()"
                :rules="[{ required: false}]"
        />

        <van-popup v-model="popShow" position="bottom" class="multiple">
            <div class="segment-btn">
                <div @click="onCancle">取消</div>
                <div @click="onConfirm">确定</div>
            </div>
            <van-checkbox-group v-model="multipleArr" >
                <van-cell-group>
                    <van-cell
                            v-for="(item, index) in lists"
                            clickable
                            :key="item.VALUE"
                            :title="`${item.LABEL_NAME}`"
                            @click="toggle(index)"
                    >
                        <template #right-icon>
                            <van-checkbox :name="item.VALUE" ref="checkboxes"/>
                        </template>
                    </van-cell>
                </van-cell-group>
            </van-checkbox-group>
        </van-popup>
    </div>
</template>

<script>
    import common from '@/api/common';

    export default {
        name: "multiple",
        props: {
            sdata: String, // segment 领域
            label: String,
            type: String,
            required: Boolean,
            sVal: String
        },
        data() {
            return {
                fieldModel: '', // 用于在输入框显示 label的值
                popShow: false,
                multipleArr: [], // 多选选中的值的数组
                multipleVal: '',
                lists: [], // 原始数据
            }
        },
        watch: {
            sVal() {
                if (this.$props.sVal) {
                    this.fieldModel = this.$props.sVal
                }
            }
        },
        mounted() {
            if (this.$props.sdata == 'segment') {
                this.lists = JSON.parse(localStorage.getItem('FIND_DIC_INFO_FAE')).SEGMENT;
            }
        },
        methods: {
            onShowField() {
                if (!this.$props.sdata) {
                    return
                }
                if (this.type == 'see') {
                    return
                }
                this.popShow = true;
            },
            errshowTip() {
                this.$toast('网络异常,请重试！');
                this.findDicInfoDictionary()
            },
            // 获取 数据字典配置的参数
            findDicInfoDictionary() {
                let fieldName = '';
                let moduleId = this.CoreNew.SYSTABLE.FAE;
                let systemId = '';
                common.findDicInfo(fieldName, moduleId, systemId).then(res => {
                    if (res && res.flag && res.data) {
                        let data = res.data;
                        localStorage.setItem('FIND_DIC_INFO_FAE', JSON.stringify(res.data));
                    } else {
                        this.$toast("网络异常，请稍后再试！");
                    }
                })
            },
            onConfirm() {
                if (this.multipleArr.length == 0) {
                    let megs = '你还未选择' + this.$props.label;
                    this.$toast(megs);
                    return
                }
                this.multipleVal = this.multipleArr.toString();
                this.fieldModel = this.calcLable(this.multipleArr).toString();
                this.popShow = false;
                this.$emit("confirm", this.multipleVal)
            },
            onCancle() {
                this.popShow = false;
                this.fieldModel = ''
                this.multipleArr = []
                this.multipleVal = ''
            },
            // 通过领域 value 获取 LABEL_NAME
            calcLable(arr) {
                let temarr = [];
                if (arr && arr.length > 0) {
                    arr.map(item => {
                        this.lists.map(citem => {
                            if (item == citem.VALUE) {
                                temarr.push(citem.LABEL_NAME)
                            }
                        });
                    });
                }
                return temarr
            },
            toggle(index) {
                this.$refs.checkboxes[index].toggle();
            },
        }
    }
</script>

<style scoped lang="less">
    .f-item {
        .van-cell {
            font-size: 14px;
            padding: 10px 16px;
        }

        /deep/ .van-field__control {
            font-size: 14px;
        }

        /deep/ textarea.van-field__control {
            min-height: 68px;
        }

        .multiple{
            .van-cell__title{
                flex: 1;
            }
        }

        .van-popup {
            height: 400px;



            .segment-btn {
                //position: absolute;
                //width: 100%;
                //box-sizing: border-box;
                //z-index: 1;
                //top: 0;
                //left: 0;
                padding: 0 15px;
                height: 40px;
                background: #eee;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .van-checkbox-group {
                width: 100%;
                position: absolute;
                height: 360px;
                overflow: scroll;
            }
        }

    }

</style>